export default "__VITE_ASSET__ButZhqa0__"